import React from "react";

export default function ProductFormFields({
  formData,
  handleChange,
}) {
  return (
    <>
      <div className="mb-3">
        <label className="form-label">Title</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          className="form-control"
          placeholder="Enter title"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">
          Description
        </label>

        <textarea
          name="description"
          className="form-control"
          rows="4"
          value={formData.description}
          onChange={handleChange}
          placeholder="Write description"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Price</label>
        <input
          type="number"
          name="price"
          value={formData.price}
          onChange={handleChange}
          className="form-control"
          placeholder="Enter price"
        />
      </div>

      {/* DISCOUNT PRICE */}
      {/* <div className="mb-3">
        <label className="form-label">
          Discount Price
        </label>
        <input
          type="number"
          name="discount_price"
          value={formData.discount_price}
          onChange={handleChange}
          className="form-control"
          placeholder="Discount price"
        />
      </div> */}
      <div className="mb-3">
        <label className="form-label">Guest</label>
        <input
          type="number"
          name="guest"
          value={formData.guest}
          onChange={handleChange}
          className="form-control"
          placeholder="Guest"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">
          Bedroom
        </label>
        <input
          type="number"
          name="bedroom"
          value={formData.bedroom}
          onChange={handleChange}
          className="form-control"
          placeholder="Bedroom"
        />
      </div>

      {/* BED */}
      <div className="mb-3">
        <label className="form-label">Bed</label>
        <input
          type="number"
          name="bed"
          value={formData.bed}
          onChange={handleChange}
          className="form-control"
          placeholder="Bed"
        />
      </div>

      {/* BATHROOM */}
      <div className="mb-3">
        <label className="form-label">
          Bathroom
        </label>
        <input
          type="number"
          name="bathroom"
          value={formData.bathroom}
          onChange={handleChange}
          className="form-control"
          placeholder="Bathroom"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">
          Address
        </label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
          className="form-control"
          placeholder="Address"
        />
      </div>

      {/* LATITUDE */}
      <div className="mb-3">
        <label className="form-label">
          Latitude
        </label>
        <input
          type="text"
          name="latitude"
          value={formData.latitude}
          onChange={handleChange}
          className="form-control"
          placeholder="Latitude"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">
          Longitude
        </label>
        <input
          type="text"
          name="longitude"
          value={formData.longitude}
          onChange={handleChange}
          className="form-control"
          placeholder="Longitude"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">
          No Of Reviews
        </label>
        <input
          type="number"
          name="noOfReviews"
          value={formData.noOfReviews}
          onChange={handleChange}
          className="form-control"
          placeholder="Reviews"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Rating</label>
        <input
          type="number"
          name="rating"
          value={formData.rating}
          onChange={handleChange}
          className="form-control"
          placeholder="Rating"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Status</label>
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="form-select"
        >
          <option value="active">
            Active
          </option>

          <option value="inactive">
            Inactive
          </option>
        </select>
      </div>
      {/* BOOKING STATUS */}
<div className="mb-3">
  <label className="form-label">
    Booking Status
  </label>

  <select
    name="bookingStatus"
    value={formData.bookingStatus}
    onChange={handleChange}
    className="form-select"
  >
    <option value="0">
      Available
    </option>

    <option value="1">
      Booked
    </option>
  </select>
</div>

    </>
  );
}